<script>
import periodList from "../periods/periodList.vue";
import equipmentTable from "../cost breakdown/equipmentTable.vue";

export default {
  name: "requirement-modal",
  components: {
    periodList,
    equipmentTable,
  },
  data: function() {
    return {
      defaultRequirement: {
        RequirementId: null,
        ChartererCompanyId: "",
        Contract: "",
        ContractNotes: "",
        ChartererContactPerson: "",
        ChartererContactId: "",
        ChartererNote: "",
        RequirementPeriods: [
          {
            PeriodType: "Day By Day",
            PeriodDurationCount: 14,
            PeriodDurationType: "Days",
            SortOrder: 0,
            Quantity: 1,
            Option: 1,
            Note: "",
            LatestRedeliveryDate: "",
            DailyRate: null,
            DailyRateCurrency: "",
            OnHireDate: null,
            OffHireDate: null,
            DateFixed: null,
            IsAlternateOption: false,
          },
        ],
        CostBreakdownTemplateItems: this.getDefaultCostItems(),
        RequirementPeriodsFreeHandText: "",
        RequirementVessels: [{ Key: "", Value: "1" }],
        Status: "OPN",
        RequirementType: "",
        IsPrivate: false,
        SendNotification: false,
        DeliveryDateStart: "",
        DeliveryDateEnd: null,
        IsExclusive: false,
        Duty: "",
        DutyNotes: "",
        AdditionalNote: "",
        DeliveryLocations: [],
        DeliveryLocationNotes: "",
        CommencementNote: "Exact time to be advised by Charterers",
        RedeliveryLocations: [],
        RedeliveryLocationNotes: "",
        PeriodNotes: "",
        Assets: [],
        Brokers: [],
        OffersReleasedToPortal: false,
        PortalAccessType: "all",
        OwnerPortalVisibility: [],
        SendRequirementNotification: false,
        OfferDueDate: "",
        CreatedUser: new Date().toISOString(),
        OfferTemplateId: null,
        TemplateFields: [],
        SupportingDocuments: "",
      },
      requirement: {
        RequirementId: null,
        ChartererCompanyId: "",
        Contract: "",
        ContractNotes: "",
        ChartererContactPerson: "",
        ChartererContactId: "",
        ChartererNote: "",
        RequirementPeriods: [
          {
            PeriodType: "Day By Day",
            PeriodDurationCount: 14,
            PeriodDurationType: "Days",
            SortOrder: 0,
            Quantity: 1,
            Option: 1,
            Note: "",
            LatestRedeliveryDate: "",
            DailyRate: null,
            DailyRateCurrency: "",
            OnHireDate: null,
            OffHireDate: null,
            DateFixed: null,
            IsAlternateOption: false,
          },
        ],
        CostBreakdownTemplateItems: this.getDefaultCostItems(),
        RequirementPeriodsFreeHandText: "",
        RequirementVessels: [{ Key: "", Value: "1" }],
        Status: "OPN",
        RequirementType: "",
        IsPrivate: false,
        SendNotification: false,
        DeliveryDateStart: "",
        DeliveryDateEnd: null,
        IsExclusive: false,
        Duty: "",
        DutyNotes: "",
        AdditionalNote: "",
        DeliveryLocations: [],
        DeliveryLocationNotes: "",
        CommencementNote: "Exact time to be advised by Charterers",
        RedeliveryLocations: [],
        RedeliveryLocationNotes: "",
        PeriodNotes: "",
        Assets: [],
        Brokers: [],
        OffersReleasedToPortal: false,
        PortalAccessType: "all",
        OwnerPortalVisibility: [],
        SendRequirementNotification: false,
        OfferDueDate: "",
        CreatedUser: new Date(),
        OfferTemplateId: null,
        TemplateFields: [],
        SupportingDocuments: "",
      },
      allCharterers: [],
      allBrokers: [],
      allAssets: [],
      allLocations: [],
      allDocumentTypes: [],
      allDuties: [],
      allVesselTypes: [],
      allPortalAccessTypes: [],
      contractsByCharterer: [],
      allRequirementStatuses: [],
      allOwners: [],
      allOfferTemplates: [],
      allTemplateFields: [],
      termTypes: [
        { Key: "TRM", Value: "Term" },
        { Key: "SPT", Value: "Spot" },
      ],
      requiredRule: [(v) => !!v || "Required"],
      requiredRuleArray: [(v) => (!!v && v.length > 0) || "Required"],
      chartererDetails: "",
      isDeliveryWindow: false,
      showDutyNotes: false,
      deliveryStartMenu: false,
      offerDueDateMenu: false,
      deliveryEndMenu: false,
      createdMenu: false,
      showDeliveryNotes: false,
      showRedeliveryNotes: false,
      showTemplateFields: false,
      allowedMinutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
      deliveryStartFormatted: "",
      deliveryEndFormatted: "",
      createdFormatted: "",
      deliverylocationSearch: "",
      redeliverylocationSearch: "",
      assetSearch: "",
      portalAccessSearch: "",
      brokerSearch: "",
      tab: null,
      generalIssue: false,
      periodIssue: false,
      equipmentIssue: false,
      cargoIssue: false,
    };
  },
  methods: {
    async getRequirement() {
      var result = await this.$store.dispatch("getRequest", { controller: "projectsApi", method: `GetRequirement`, parameters: { id: this.itemId } });

      result.DeliveryDateStart = result.DeliveryDateStart.split("T")[0];
      if (result.DeliveryDateEnd) {
        result.DeliveryDateEnd = result.DeliveryDateEnd.split("T")[0];
      }
      result.DeliveryDateStart = result.DeliveryDateStart.split("T")[0];

      this.requirement = result;
      //set dastetime fields to date objects

      this.requirement.OfferDueDate = new Date(this.requirement.OfferDueDate);
      this.requirement.CreatedUser = new Date(this.requirement.CreatedUser);

      if (this.requirement.DeliveryDateEnd) {
        this.isDeliveryWindow = true;
      } else {
        this.isDeliveryWindow = false;
      }
      if (this.requirement.DeliveryLocationNotes) {
        this.showDeliveryNotes = true;
      } else {
        this.showDeliveryNotes = false;
      }
      if (this.requirement.RedeliveryLocationNotes) {
        this.showRedeliveryNotes = true;
      } else {
        this.showRedeliveryNotes = false;
      }
      if (this.requirement.DutyNotes) {
        this.showDutyNotes = true;
      } else {
        this.showDutyNotes = false;
      }
      if (this.requirement.OfferTemplateId) {
        var self = this;
        await this.getOfferTemplates();
        this.allTemplateFields = this.allOfferTemplates.filter(function(x) {
          return x.OfferTemplateId == self.requirement.OfferTemplateId;
        })[0].TemplateFields;
      }
    },
    closeModal() {
      this.resetValidation();
      this.$store.commit("setActiveRequirementModal", { visible: false, id: null });
    },
    resetValidation() {
      this.$refs.generalform.resetValidation();
      this.$refs.periodform.resetValidation();
      this.$refs.equipmentform.resetValidation();
    },
    async createOrUpdate() {
      if (this.isValid()) {
        this.$store.commit("setLoadingAnimation", {
          show: true,
        });
        var req = this.requirement;
        await this.$store.dispatch("postRequest", { controller: "projectsApi", method: `CreateOrUpdateRequirement`, parameters: req });
        this.$store.commit("setMessage", {
          type: "success",
          content: `Requirement Successfully ${req.RequirementId ? "Updated" : "Added"}`,
        });
        this.$store.commit("setLoadingAnimation", null);
        this.closeModal();
      }
    },
    isValid() {
      return this.isGeneralValid() && this.isPeriodValid() && this.isEquipmentValid();
    },
    isGeneralValid() {
      this.generalIssue = !this.$refs.generalform.validate();
      return !this.generalIssue;
    },
    isPeriodValid() {
      this.periodIssue = !this.$refs.periodform.validate();
      return !this.periodIssue;
    },
    isEquipmentValid() {
      this.equipmentIssue = !this.$refs.equipmentform.validate();
      return !this.equipmentIssue;
    },
    onDeleteItem() {
      this.$refs.form.delete();
    },
    async getCharterers() {
      this.allCharterers = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllChartererCompaniesDropdown` });
    },
    async getBrokers() {
      this.allBrokers = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllBrokerCompaniesDropdown` });
    },
    async getAssets() {
      this.allAssets = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllAssetsForDropdown` });
    },
    async getLocations() {
      this.allLocations = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllLocationsDropdown` });
    },
    async getDocumentTypes() {
      this.allDocumentTypes = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetDocumentTypes` });
    },
    async getDuties() {
      this.allDuties = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetDutyTypes` });
    },
    async getAllVesselTypes() {
      this.allVesselTypes = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetVesselTypes` });
    },
    async getOfferTemplates() {
      this.allOfferTemplates = await this.$store.dispatch("getRequest", {
        controller: "offertemplate",
        method: `GetOfferTemplatesForRequirementRaw`,
        parameters: { chartererId: this.requirement.ChartererCompanyId, termType: this.requirement.termType },
      });
    },
    async getChartererDetails() {
      this.contractsByCharterer = await this.$store.dispatch("getRequest", { controller: "company", method: `GetCompanyContractsTextOnly`, parameters: { id: this.requirement.ChartererCompanyId } });
      this.chartererDetails = await this.$store.dispatch("getRequest", { controller: "company", method: `GetCompanyDetails`, parameters: { companyId: this.requirement.ChartererCompanyId } });
      this.getOfferTemplates();
    },
    async getAllRequirementStatus() {
      this.allRequirementStatuses = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetRequirementStatus` });
    },
    async getPortalAccessTypes() {
      this.allPortalAccessTypes = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetPortalAccessTypes` });
    },
    async getAllOwners() {
      this.allOwners = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllOwnerCompaniesDropdown` });
    },
    async setChartererDefaults() {
      var data = this.chartererDetails;
      var requirement = this.requirement;
      if (data.model.DefaultAsExclusive) {
        requirement.IsExclusive = true;
      }

      if (data.model.DefaultLocations) {
        var locations = this.parseStringList(data.model.DefaultLocations);
        requirement.DeliveryLocations = locations;
        requirement.RedeliveryLocations = locations;
      }

      if (data.model.DefaultBrokers) {
        requirement.Brokers = this.parseStringList(data.model.DefaultBrokers);
      }
      if (data.notes) {
        requirement.AdditionalNote = data.notes;
      }
      if (data.DefaultContract) {
        requirement.Contract = data.DefaultContract;
      }
      if (data.model.ShowRequirementInApp) {
        requirement.SendRequirementNotification = true;
      }
    },
    onHideDutyNotes() {
      this.showDutyNotes = false;
      this.requirement.DutyNotes = "";
    },
    onHideDeliveryNotes() {
      this.showDeliveryNotes = false;
      this.requirement.DeliveryLocationNotes = "";
    },
    onHideRedeliveryNotes() {
      this.showRedeliveryNotes = false;
      this.requirement.RedeliveryLocationNotes = "";
    },
    onAddVesselTypeClick() {
      this.requirement.RequirementVessels.push({ Key: "", Value: 1 });
    },
    removeVesselType(index) {
      this.requirement.RequirementVessels.splice(index, 1);
    },
    hideEndDate() {
      this.isDeliveryWindow = false;
      this.requirement.DeliveryDateEnd = null;
    },
    parseStringList(list) {
      return list.indexOf(",") > -1
        ? list.split(",").map(function(x) {
            return x.trim();
          })
        : list.length
        ? [list]
        : [];
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      if (date.indexOf("T") > -1) {
        date = date.split("T")[0];
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    parseOnLoad() {},
    onOfferTemplateSelect() {
      var self = this;
      if (self.requirement.OfferTemplateId) {
        this.allTemplateFields = this.allOfferTemplates.filter(function(x) {
          return x.OfferTemplateId == self.requirement.OfferTemplateId;
        })[0].TemplateFields;
        this.requirement.TemplateFields = this.allTemplateFields;
      } else {
        this.requirement.TemplateFields = [];
      }
    },
    getDefaultCostItems() {
      var result = [];
      var allItems = [
        { cat: "Vessel Marine Manning", desc: "Vessel Master", id: "VMM-1" },
        { cat: "Vessel Marine Manning", desc: "Chief Officer", id: "VMM-2" },
        { cat: "Vessel Marine Manning", desc: "Second Officer", id: "VMM-3" },
        { cat: "Vessel Marine Manning", desc: "Chief Engineer", id: "VMM-4" },
        { cat: "Vessel Marine Manning", desc: "Second Engineer", id: "VMM-5" },
        { cat: "Vessel Marine Manning", desc: "Third Engineer", id: "VMM-6" },
        { cat: "Vessel Marine Manning", desc: "Motorman", id: "VMM-7" },
        { cat: "Vessel Marine Manning", desc: "ETO", id: "VMM-8" },
        { cat: "Vessel Marine Manning", desc: "Crane Operator", id: "VMM-9" },
        { cat: "Vessel Marine Manning", desc: "AB", id: "VMM-10" },
        { cat: "Vessel Marine Manning", desc: "Chief Steward", id: "VMM-11" },
        { cat: "Vessel Marine Manning", desc: "Cook", id: "VMM-12" },
        { cat: "Vessel Marine Manning", desc: "Steward", id: "VMM-13" },
        { cat: "Survey Manning", desc: "Party Chief", id: "SM-1" },
        { cat: "Survey Manning", desc: "Senior Surveyor", id: "SM-2" },
        { cat: "Survey Manning", desc: "Survey Technician", id: "SM-3" },
        { cat: "ROV Manning", desc: "ROV Supervisor", id: "ROV-1" },
        { cat: "ROV Manning", desc: "ROV Pilot/Technician", id: "ROV-2" },
        { cat: "Project Manning", desc: "Offshore Manager", id: "PM-1" },
        { cat: "Project Manning", desc: "Shift Supervisor", id: "PM-2" },
        { cat: "Project Manning", desc: "Medic", id: "PM-3" },
        { cat: "Project Manning", desc: "Deck Foreman", id: "PM-4" },
        { cat: "Project Manning", desc: "Rigger/Welder", id: "PM-5" },
        { cat: "Vessel Equipment", desc: "WROV 1", id: "VE-1" },
        { cat: "Vessel Equipment", desc: "WROV 2", id: "VE-2" },
        { cat: "Other Equipment", desc: "75mm HD Wire Cutter", id: "OE-1" },
        { cat: "Other Equipment", desc: "Manipulator Camera", id: "OE-2" },
        { cat: "Other Equipment", desc: "LP Water Jet", id: "OE-3" },
        { cat: "Other Equipment", desc: "Minibeacon", id: "OE-4" },
      ];
      for (var i = 0; i < allItems.length; i++) {
        result.push(this.createCostItem(allItems[i].cat, allItems[i].desc, allItems[i].id));
      }

      return result;
    },
    createCostItem(category, description, id) {
      return {
        ItemId: id,
        Category: category,
        Description: description,
        NumberOfCrew: null,
        IncludedInDayRate: false,
        Cost: null,
        Currency: "",
        MobilisationCost: null,
        MobilisationCurrency: "",
        MobilisationCostText: "",
        DemobilisationCost: null,
        DemobilisationCurrency: "",
        DemobilisationCostText: "",
        Comment: "",
      };
    },
    allowedDeliveryDates(val) {
      var asDate = new Date(val);
      asDate.setHours(0, 0, 0, 0);
      if (this.requirement.RequirementId) {
        if (this.requirement.DeliveryDateEnd) {
          var deliveryEndAsDate = new Date(this.requirement.DeliveryDateEnd);
          deliveryEndAsDate.setHours(0, 0, 0, 0);
          return asDate < deliveryEndAsDate;
        } else {
          return true;
        }
      } else {
        var now = new Date();
        now.setHours(0, 0, 0, 0);

        if (this.requirement.DeliveryDateEnd) {
          var deliveryEndAsDate = new Date(this.requirement.DeliveryDateEnd);
          deliveryEndAsDate.setHours(0, 0, 0, 0);

          return asDate >= now && asDate < deliveryEndAsDate;
        } else {
          return asDate >= now;
        }
      }
    },
    allowedRedeliveryDates(val) {
      var asDate = new Date(val);
      asDate.setHours(0, 0, 0, 0);
      if (this.requirement.RequirementId) {
        if (this.requirement.DeliveryDateStart) {
          var deliveryStartAsDate = new Date(this.requirement.DeliveryDateStart);
          deliveryStartAsDate.setHours(0, 0, 0, 0);
          return asDate > deliveryStartAsDate;
        } else {
          return true;
        }
      } else {
        var now = new Date();
        now.setHours(0, 0, 0, 0);

        if (this.requirement.DeliveryDateStart) {
          var deliveryStartAsDate = new Date(this.requirement.DeliveryDateStart);
          deliveryStartAsDate.setHours(0, 0, 0, 0);

          return asDate >= now && asDate > deliveryStartAsDate;
        } else {
          return asDate >= now;
        }
      }
    },
    allowedOffersDueDates(val) {
      var asDate = new Date(val);
      asDate.setHours(0, 0, 0, 0);
      if (this.requirement.RequirementId) {
        if (this.requirement.DeliveryDateStart) {
          var deliveryStartAsDate = new Date(this.requirement.DeliveryDateStart);
          deliveryStartAsDate.setHours(0, 0, 0, 0);
          return asDate < deliveryStartAsDate;
        } else {
          return true;
        }
      } else {
        var now = new Date();
        now.setHours(0, 0, 0, 0);
        if (this.requirement.DeliveryDateStart) {
          var deliveryStartAsDate = new Date(this.requirement.DeliveryDateStart);
          deliveryStartAsDate.setHours(0, 0, 0, 0);
          return asDate < deliveryStartAsDate && asDate > now;
        } else {
          return asDate > now;
        }
      }
    },
  },
  computed: {
    itemId() {
      return this.$store.state.requirementModal.id;
    },
    isEdit() {
      return this.itemId !== null;
    },
    visible: function() {
      return this.$store.state.requirementModal && this.$store.state.requirementModal.visible;
    },
  },
  async mounted() {
    await this.getChartererDetails();
  },
  watch: {
    async itemId(val) {
      if (val) {
        await this.getRequirement();
      } else {
        this.requirement = JSON.parse(JSON.stringify(this.defaultRequirement));
        this.requirement.CreatedUser = new Date();
      }
      this.tab = 1;
      if (this.$refs.content) {
        this.$refs.content.scrollTop = 0;
      }
    },
    async "requirement.ChartererCompanyId"(val) {
      if (val) {
        await this.getChartererDetails();
        if (!this.requirement.RequirementId) {
          this.setChartererDefaults();
        }
      }
    },
    "requirement.DeliveryDateStart"(val) {
      this.deliveryStartFormatted = this.formatDate(val);
      console.log("qwe4");
    },
    "requirement.DeliveryDateEnd"(val) {
      this.deliveryEndFormatted = this.formatDate(val);
    },
    "requirement.RequirementPeriods"(val, old) {
      console.log(val, old);
    },
  },
  async mounted() {
    await this.getCharterers();
    await this.getBrokers();
    await this.getAssets();
    await this.getLocations();
    await this.getDocumentTypes();
    await this.getDuties();
    await this.getAllVesselTypes();
    await this.getAllRequirementStatus();
    await this.getPortalAccessTypes();
    await this.getAllOwners();
  },
};
</script>
<template>
  <div>
    <v-row justify="center">
      <v-dialog :value="visible" max-width="80%" scrollable persistent>
        <v-card>
          <v-card-title>
            <span class="headline primary--text"
              >{{ isEdit ? `Edit Requirement` : `Add Requirement` }}<i v-if="isEdit" class="fas fa-edit icon-right"></i><i v-else class="fas fa-plus icon-right"></i
            ></span>
            <v-btn icon dark @click="closeModal()" style="position:absolute;right:5px;top:5px;">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text ref="content">
            <v-stepper v-model="tab" alt-labels non-linear style="overflow:visible">
              <v-stepper-header class="sticky">
                <v-stepper-step step="1" @click.native="tab = 1" editable complete edit-icon="mdi-information-variant" :rules="[() => !generalIssue]"> General Information</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2" @click.native="tab = 2" editable complete edit-icon="mdi-chart-timeline" :rules="[() => !periodIssue]"> Period</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3" @click.native="tab = 3" editable complete edit-icon="mdi-cash-multiple" :rules="[() => !equipmentIssue]">Equipment</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="4" @click.native="tab = 4" editable complete edit-icon="mdi-cube-send" :rules="[() => !cargoIssue]">Cargo</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1" class="pt-0">
                  <v-form ref="generalform">
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <span class="text-subtitle primary--text">General Information</span>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              :rules="requiredRule"
                              hide-details="auto"
                              v-model="requirement.ChartererCompanyId"
                              item-text="Value"
                              item-value="Key"
                              :items="allCharterers"
                              outlined
                              label="Charterer"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-combobox :items="allDuties" dense :rules="requiredRule" hide-details="auto" v-model="requirement.Duty" outlined label="Duties"
                              ><template slot="append-outer">
                                <v-icon v-if="!showDutyNotes" @click="showDutyNotes = true" title="Add More Duty Details">mdi-text-box-plus-outline</v-icon
                                ><v-icon v-else @click="onHideDutyNotes" title="Remove additional duty details">mdi-text-box-remove-outline</v-icon></template
                              ></v-combobox
                            >
                          </v-col>
                          <v-col cols="12" v-if="showDutyNotes">
                            <v-textarea rows="2" dense hide-details="auto" v-model="requirement.DutyNotes" outlined label="Duty Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12" class="pb-0">
                            <span>Required Vessels<v-icon class="ml-2" title="Click to add" @click="onAddVesselTypeClick()">mdi-plus-circle</v-icon></span>
                          </v-col>

                          <v-col cols="12" v-if="allVesselTypes.length && requirement.RequirementVessels.length" class="py-0">
                            <v-row v-for="(vessel, i) in requirement.RequirementVessels" :key="`${i}_vessel_type`">
                              <v-col cols="6">
                                <v-select
                                  dense
                                  :rules="requiredRule"
                                  hide-details="auto"
                                  v-model="vessel.Key"
                                  item-text="Value"
                                  item-value="Key"
                                  :items="allVesselTypes"
                                  outlined
                                  label="Type"
                                ></v-select>
                              </v-col>
                              <v-col cols="6">
                                <v-text-field dense type="number" v-model.number="vessel.Value" :rules="requiredRule" hide-details="auto" outlined label="Quantity" prepend-icon="mdi-alpha-x"
                                  ><template slot="append-outer">
                                    <v-icon @click="removeVesselType(i)" v-if="requirement.RequirementVessels.length > 1">mdi-delete-circle</v-icon>
                                  </template></v-text-field
                                >
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              :rules="requiredRuleArray"
                              hide-details="auto"
                              multiple
                              v-model="requirement.Brokers"
                              item-text="Value"
                              item-value="Key"
                              :items="allBrokers"
                              outlined
                              label="Brokers"
                              @input="brokerSearch = ''"
                              :search-input.sync="brokerSearch"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-datetime-picker
                              :timePickerProps="{ 'allowed-minutes': allowedMinutes, format: '24hr' }"
                              :datePickerProps="{ 'allowed-dates': allowedOffersDueDates }"
                              dateFormat="dd/MM/yy"
                              :textFieldProps="{ 'hide-details': 'auto', outlined: true, dense: true, rules: requiredRule }"
                              label="Offers Due By"
                              dense
                              v-model="requirement.OfferDueDate"
                            >
                            </v-datetime-picker>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              dense
                              :rules="requiredRule"
                              hide-details="auto"
                              v-model="requirement.Status"
                              item-text="Value"
                              item-value="Key"
                              :items="allRequirementStatuses"
                              outlined
                              label="Status"
                            ></v-select>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              dense
                              :rules="requiredRule"
                              hide-details="auto"
                              v-model="requirement.RequirementType"
                              item-text="Value"
                              item-value="Key"
                              :items="termTypes"
                              outlined
                              label="Term Type"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <span class="text-subtitle primary--text">Delivery Details</span>
                          </v-col>
                          <v-col cols="12" v-if="!isDeliveryWindow">
                            <v-menu v-model="deliveryStartMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  dense
                                  outlined
                                  hide-details
                                  :rules="requiredRule"
                                  v-model="deliveryStartFormatted"
                                  label="Delivery date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  @blur="requirement.DeliveryDateStart = parseDate(deliveryStartFormatted)"
                                  ><template slot="append-outer">
                                    <v-icon @click="isDeliveryWindow = !isDeliveryWindow" title="Switch to delivery window">mdi-calendar-multiple</v-icon></template
                                  ></v-text-field
                                >
                              </template>
                              <v-date-picker v-model="requirement.DeliveryDateStart" @input="deliveryStartMenu = false" :allowed-dates="allowedDeliveryDates"></v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col v-else cols="6">
                            <v-menu v-model="deliveryStartMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  outlined
                                  hide-details
                                  :rules="requiredRule"
                                  v-model="deliveryStartFormatted"
                                  label="Earliest Delivery"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  @blur="requirement.DeliveryDateStart = parseDate(deliveryStartFormatted)"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="requirement.DeliveryDateStart" @input="deliveryStartMenu = false" :allowed-dates="allowedDeliveryDates"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6" v-if="isDeliveryWindow">
                            <v-menu v-model="deliveryEndMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  outlined
                                  hide-details
                                  :rules="requiredRule"
                                  v-model="deliveryEndFormatted"
                                  label="Latest Delivery"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  @blur="requirement.DeliveryDateEnd = parseDate(deliveryEndFormatted)"
                                  ><template slot="append-outer"> <v-icon @click="hideEndDate" title="Switch to single delivery date">mdi-calendar-arrow-left</v-icon></template></v-text-field
                                >
                              </template>
                              <v-date-picker v-model="requirement.DeliveryDateEnd" @input="deliveryEndMenu = false" :allowed-dates="allowedRedeliveryDates"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea rows="2" dense hide-details="auto" v-model="requirement.CommencementNote" outlined label="Delivery Date Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              :rules="requiredRuleArray"
                              hide-details="auto"
                              v-model="requirement.DeliveryLocations"
                              item-text="Value"
                              item-value="Key"
                              :items="allLocations"
                              outlined
                              multiple
                              label="Delivery Location"
                              @input="deliverylocationSearch = ''"
                              :search-input.sync="deliverylocationSearch"
                              ><template slot="append-outer">
                                <v-icon v-if="!showDeliveryNotes" @click="showDeliveryNotes = true" title="Add more delivery location details">mdi-text-box-plus-outline</v-icon
                                ><v-icon v-else @click="onHideDeliveryNotes" title="Remove delivery location details">mdi-text-box-remove-outline</v-icon></template
                              ></v-autocomplete
                            >
                          </v-col>
                          <v-col cols="12" v-if="showDeliveryNotes">
                            <v-textarea rows="2" dense hide-details="auto" v-model="requirement.DeliveryLocationNotes" outlined label="Delivery Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              :rules="requiredRuleArray"
                              hide-details="auto"
                              multiple
                              v-model="requirement.RedeliveryLocations"
                              item-text="Value"
                              item-value="Key"
                              :items="allLocations"
                              outlined
                              label="Redelivery Location"
                              @input="redeliverylocationSearch = ''"
                              :search-input.sync="redeliverylocationSearch"
                              ><template slot="append-outer">
                                <v-icon v-if="!showRedeliveryNotes" @click="showRedeliveryNotes = true" title="Add more redelivery location details">mdi-text-box-plus-outline</v-icon
                                ><v-icon v-else @click="onHideRedeliveryNotes" title="Remove redelivery location details">mdi-text-box-remove-outline</v-icon></template
                              ></v-autocomplete
                            >
                          </v-col>
                          <v-col cols="12" v-if="showRedeliveryNotes">
                            <v-textarea rows="2" dense hide-details="auto" v-model="requirement.RedeliveryLocationNotes" outlined label="Redelivery Notes"></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <span class="text-subtitle primary--text">Accessibility</span>
                          </v-col>
                          <v-col cols="12">
                            <v-checkbox dense hide-details v-model="requirement.IsExclusive" label="Exclusive to Seabrokers"></v-checkbox>
                          </v-col>
                          <v-col cols="12">
                            <v-checkbox dense hide-details v-model="requirement.IsPrivate" label="Hide from Public View"></v-checkbox>
                          </v-col>
                          <v-col cols="12">
                            <v-checkbox dense hide-details v-model="requirement.SendNotification" label="Send Notification"></v-checkbox>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              dense
                              :rules="requiredRule"
                              hide-details="auto"
                              v-model="requirement.PortalAccessType"
                              :items="allPortalAccessTypes"
                              item-text="Value"
                              item-value="Key"
                              outlined
                              label="Seaportal Accessibility"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" v-if="requirement.PortalAccessType == 'owners'">
                            <v-autocomplete
                              dense
                              :rules="requiredRule"
                              hide-details="auto"
                              multiple
                              v-model="requirement.OwnerPortalVisibility"
                              item-text="Value"
                              item-value="Key"
                              :items="allOwners"
                              outlined
                              label="Owners with Requirement Access"
                              @input="portalAccessSearch = ''"
                              :search-input.sync="portalAccessSearch"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <span class="text-subtitle primary--text">Additional Details</span>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea dense rows="3" outlined hide-details="auto" v-model="requirement.SupportingDocuments" label="Supporting Documents"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              :rules="requiredRule"
                              hide-details="auto"
                              v-model="requirement.Assets"
                              item-text="Value"
                              item-value="Key"
                              :items="allAssets"
                              outlined
                              multiple
                              label="Assets"
                              @input="assetSearch = ''"
                              :search-input.sync="assetSearch"
                            ></v-autocomplete>
                          </v-col>

                          <v-col cols="12">
                            <v-combobox dense hide-details="auto" v-model="requirement.Contract" :items="contractsByCharterer" outlined label="Contract"></v-combobox>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea rows="2" dense hide-details="auto" v-model="requirement.ContractNotes" outlined label="Contract Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea rows="2" dense hide-details="auto" v-model="requirement.AdditionalNote" outlined label="General Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-datetime-picker
                              :timePickerProps="{ 'allowed-minutes': allowedMinutes, format: '24hr' }"
                              dateFormat="dd/MM/yy"
                              :textFieldProps="{ 'hide-details': 'auto', outlined: true, dense: true }"
                              label="Created Date"
                              :rules="requiredRule"
                              dense
                              v-model="requirement.CreatedUser"
                            >
                            </v-datetime-picker>
                          </v-col>
                          <!--                           <v-col cols="12">
                            <v-select
                              dense
                              hide-details="auto"
                              v-model="requirement.OfferTemplateId"
                              :items="allOfferTemplates"
                              item-text="Name"
                              item-value="OfferTemplateId"
                              outlined
                              label="Offer Template"
                              @change="onOfferTemplateSelect"
                              ><template slot="append-outer">
                                <v-icon v-if="!showTemplateFields" @click="showTemplateFields = true" title="Show Template Fields">mdi-eye-outline</v-icon
                                ><v-icon v-else @click="showTemplateFields = false" title="Hide Template Fields">mdi-eye-off-outline</v-icon></template
                              ></v-select
                            >
                          </v-col>
                          <v-col cols="12" v-if="showTemplateFields">
                            <v-autocomplete
                              multiple
                              dense
                              hide-details="auto"
                              v-model="requirement.TemplateFields"
                              :items="allTemplateFields"
                              item-text="Name"
                              return-object
                              outlined
                              label="Included Template Fields"
                            ></v-autocomplete>
                          </v-col> -->
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-form ref="periodform">
                    <v-row>
                      <v-col cols="12">
                        <span class="text-subtitle primary--text">Period Details</span>
                      </v-col>
                      <v-col cols="12">
                        <period-list :periods="requirement.RequirementPeriods" type="requirement"></period-list>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea rows="2" dense hide-details="auto" v-model="requirement.RequirementPeriodsFreeHandText" outlined label="Period Notes"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <v-form ref="equipmentform">
                    <equipment-table :items.sync="requirement.CostBreakdownTemplateItems" :hide-costs="true"></equipment-table>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content step="4">
                  <v-form ref="cargoform">
                    COMING SOON!
                  </v-form>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="closeModal()">
              Cancel
            </v-btn>
            <v-btn class="warning" @click="onDeleteItem()">
              Delete
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn class="success--text" @click="createOrUpdate()">
              {{ isEdit ? `Save Changes` : `Add` }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<style>
.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  background-image: linear-gradient(white 80%, transparent);
  z-index: 1;
}
.v-stepper__header {
  box-shadow: none;
}
</style>
